import React, { useEffect, useState } from 'react';
import '../../scss/components/_adminSearchFilterPanel.scss';

const AdminSearchFilterPanel = ({
    title = 'Поиск и фильтры',
    summary = '',
    defaultOpen = false,
    open: controlledOpen,
    onOpenChange,
    searchValue = '',
    onSearchChange,
    searchLabel = 'Поиск товара',
    searchPlaceholder = 'Название, артикул, категория, тег',
    disabled = false,
    children = null,
    className = '',
}) => {
    const [internalOpen, setInternalOpen] = useState(defaultOpen === true);
    const controlled = typeof controlledOpen === 'boolean';
    const open = controlled ? controlledOpen : internalOpen;

    useEffect(() => {
        if (!controlled) setInternalOpen(defaultOpen === true);
    }, [controlled, defaultOpen]);

    const toggle = () => {
        const next = !open;
        if (!controlled) setInternalOpen(next);
        onOpenChange?.(next);
    };

    return (
        <section className={[
            'adminSearchFilterPanel',
            open ? 'is-open' : 'is-collapsed',
            className,
        ].filter(Boolean).join(' ')}>
            <button
                type="button"
                className="adminSearchFilterPanel__head"
                onClick={toggle}
                aria-expanded={open}
            >
                <span className="adminSearchFilterPanel__headText">
                    <strong>{title}</strong>
                    <small>{summary || 'Поиск и дополнительные фильтры'}</small>
                </span>
                <span className="adminSearchFilterPanel__toggle">
                    {open ? 'Свернуть' : 'Развернуть'}
                    <i aria-hidden="true">{open ? '▲' : '▼'}</i>
                </span>
            </button>

            {open ? (
                <div className="adminSearchFilterPanel__body">
                    {typeof onSearchChange === 'function' ? (
                        <label className="adminSearchFilterPanel__search">
                            <span>{searchLabel}</span>
                            <input
                                type="text"
                                value={searchValue}
                                placeholder={searchPlaceholder}
                                onChange={(event) => onSearchChange(event.target.value)}
                                disabled={disabled}
                            />
                        </label>
                    ) : null}

                    {children ? (
                        <div className="adminSearchFilterPanel__content">
                            {children}
                        </div>
                    ) : null}
                </div>
            ) : null}
        </section>
    );
};

export default AdminSearchFilterPanel;
